import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { chargeApi, chargeLabel, chargeStatic } from "./charge.config";

const { Title } = Typography;
const dateFormat = "YYYY/MMMM/DD";

const EditCharge = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const chargeApplyToCurrent = Form.useWatch("chargeAppliesTo", form);
  const chargeTimeType = Form.useWatch("chargeTimeType", form);
  const enablePaymentType = Form.useWatch("enablePaymentType", form);
  const enableFreeWithdrawalCharge = Form.useWatch(
    "enableFreeWithdrawalCharge",
    form
  );
  const addFeeFrequencyCheck = Form.useWatch("addfeefrequency", form);

  const [isLoading, setIsLoading] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [chargeDetail, setChargeDetail] = useState({});

  const [currencyData, setCurrencyData] = useState([]);
  const [chargeApplyData, setChargeApplyData] = useState([]);
  const [chargeMethodData, setChargeMethodData] = useState([]);
  const [chargeCalcTypeData, setChargeCalcTypeData] = useState([]);
  const [chargeTimeTypeData, setChargeTimeTypeData] = useState([]);
  const [feeFrequencyOptions, setFeeFrequencyOptions] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [incomeFromChargeOptions, setIncomeFromChargeOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);

  const [tempLoanCharge, setTempLoanCharge] = useState([]);
  const [tempLoanCalc, setTempLoanCalc] = useState([]);
  const [tempSavingsCharge, setTempSavingsCharge] = useState([]);
  const [tempSavingsCalc, setTempSavingsCalc] = useState([]);
  const [tempClientCharge, setTempClientCharge] = useState([]);
  const [tempClientCalc, setTempClientCalc] = useState([]);
  const [tempSharesCharge, setTempSharesCharge] = useState([]);
  const [tempSharesCalc, setTempSharesCalc] = useState([]);
  const [tempTreasuryCharge, setTempTreasuryCharge] = useState([]);
  const [tempTreasuryCalc, setTempTreasuryCalc] = useState([]);

  const [filteredChargeCalcTypeData, setFilteredChargeCalcTypeData] = useState(
    []
  );
  const [filteredChargeTimeTypeData, setFilteredChargeTimeTypeData] = useState(
    []
  );

  const [isMonthlyFee, setIsMonthlyFee] = useState(false);
  const [isAnnualFee, setIsAnnualFee] = useState(false);
  const [isWeeklyFee, setIsWeeklyFee] = useState(false);
  const [isWithdrawalFee, setIsWithdrawalFee] = useState(false);
  const [appliesToLoan, setAppliesToLoan] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getPaymentTypes();
    getDetailById();
  }, []);

  useEffect(() => {
    if (filteredChargeTimeTypeData.length && chargeDetail?.chargeTimeType?.id) {
      form.setFieldsValue({
        chargeTimeType: chargeDetail.chargeTimeType.id,
      });
    }
  }, [filteredChargeTimeTypeData]);

  useEffect(() => {
    if (
      filteredChargeCalcTypeData.length &&
      chargeDetail?.chargeCalculationType?.id
    ) {
      form.setFieldsValue({
        chargeCalculationType: chargeDetail.chargeCalculationType.id,
      });
    }
  }, [filteredChargeCalcTypeData]);

  useEffect(() => {
    switch (chargeApplyToCurrent) {
      case 1:
        setFilteredChargeCalcTypeData(tempLoanCalc);
        setFilteredChargeTimeTypeData(tempLoanCharge);
        setAppliesToLoan(true);
        break;
      case 2:
        setFilteredChargeCalcTypeData(tempSavingsCalc);
        setFilteredChargeTimeTypeData(tempSavingsCharge);
        setAppliesToLoan(false);
        break;
      case 3:
        setFilteredChargeCalcTypeData(tempClientCalc);
        setFilteredChargeTimeTypeData(tempClientCharge);
        setAppliesToLoan(false);
        break;
      case 4:
        setFilteredChargeCalcTypeData(tempSharesCalc);
        setFilteredChargeTimeTypeData(tempSharesCharge);
        setAppliesToLoan(false);
        break;
      case 5:
        setFilteredChargeCalcTypeData(tempTreasuryCalc);
        setFilteredChargeTimeTypeData(tempTreasuryCharge);
        setAppliesToLoan(false);
        break;
      case 6:
        setFilteredChargeCalcTypeData([]);
        setFilteredChargeTimeTypeData([]);
        setAppliesToLoan(false);
        break;
      default:
        setFilteredChargeCalcTypeData([]);
        setFilteredChargeTimeTypeData([]);
        setAppliesToLoan(false);
        return;
    }
    form.setFieldsValue({
      chargeTimeType: undefined,
      chargeCalculationType: undefined,
    });
  }, [chargeApplyToCurrent]);

  useEffect(() => {
    if (!chargeTimeType) return;
    const label =
      filteredChargeTimeTypeData
        .find((i) => i.value === chargeTimeType)
        ?.label?.toLowerCase() || "";
    switch (label) {
      case "monthly fee":
        setIsMonthlyFee(true);
        setIsAnnualFee(true);
        setIsWeeklyFee(true);
        setIsWithdrawalFee(false);
        break;
      case "annual fee":
        setIsAnnualFee(true);
        setIsMonthlyFee(true);
        setIsWeeklyFee(false);
        setIsWithdrawalFee(false);
        break;
      case "weekly fee":
        setIsWeeklyFee(true);
        setIsMonthlyFee(true);
        setIsAnnualFee(false);
        setIsWithdrawalFee(false);
        break;
      case "withdrawal fee":
        setIsWithdrawalFee(true);
        setIsMonthlyFee(false);
        setIsAnnualFee(false);
        setIsWeeklyFee(false);
        break;
      default:
        setIsMonthlyFee(false);
        setIsAnnualFee(false);
        setIsWeeklyFee(false);
        setIsWithdrawalFee(false);
    }
  }, [chargeTimeType, filteredChargeTimeTypeData]);

  const disabledAfterCurrentDate = (current) =>
    current && current.valueOf() > Date.now();

const getDetailById = () => {
  const url = `${chargeApi.Charges}/${state.id}?template=true`;
  const body = { session };

  BOM.FetchReqAction(body, url, (err, res) => {
    if (err) {
      BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      setIsLoading(false);
      return;
    }

    setChargeDetail(res);

    // 🧠 Smart handling for feeOnMonthDay (API gives [month, day])
    let feeOnMonthDayValue;
    if (Array.isArray(res?.feeOnMonthDay) && res.feeOnMonthDay.length === 2) {
      const [month, day] = res.feeOnMonthDay;
      const currentYear = new Date().getFullYear();
      feeOnMonthDayValue = dayjs(`${currentYear}-${month}-${day}`, "YYYY-M-D");
    } else {
      feeOnMonthDayValue = undefined;
    }

    console.log(res);

    form.setFieldsValue({
      chargeAppliesTo: res?.chargeAppliesTo?.id,
      name: res?.name,
      currencyCode: res?.currency?.code,
      amount: res?.amount,
      active: res?.active,
      penalty: res?.penalty || false,
      chargeTimeType: res?.chargeTimeType?.id,
      chargeCalculationType: res?.chargeCalculationType?.id,
      chargePaymentMode: res?.chargePaymentMode?.id,
      enablePaymentType: res?.enablePaymentType,
      enableFreeWithdrawalCharge: res?.enableFreeWithdrawalCharge,
      paymentTypeId: res?.paymentType?.id,
      freeWithdrawalFrequency: res?.freeWithdrawalFrequency,
      restartCountFrequency: res?.restartCountFrequency,
      countFrequencyType: res?.countFrequencyType?.id,
      taxGroupId: res?.taxGroup?.id,
      incomeAccountId: res?.incomeAccount?.id,
      feeOnMonthDay: feeOnMonthDayValue,
      feeInterval: res?.feeInterval,
      addfeefrequency: res?.addfeeFrequency,
    });

    getTemplate(res?.chargeAppliesTo?.id, res);
  });
};


  const getTemplate = (applyToParam, existingDetail = null) => {
    const url = `${chargeApi.Charges}/template`;
    const body = { session };
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        setTemplateData(res);

        const tempChargeApply = [];
        const tempCurrency = [];
        const tempChargeMethod = [];
        const tempTaxGroup = [];
        const tempIncomeFrom = [];
        const tempFeeFrequency = [];
        const tempPaymentType = [];

        res?.chargeAppliesToOptions?.forEach((element) => {
          tempChargeApply.push({
            value: element.id,
            label: element.value,
            description: element.description,
          });
        });

        res?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        res?.chargePaymetModeOptions?.forEach((element) => {
          tempChargeMethod.push({
            value: element.id,
            label: element.value,
          });
        });

        res?.taxGroupOptions?.forEach((element) => {
          tempTaxGroup.push({
            value: element.id,
            label: element.name,
          });
        });

        res?.incomeOrLiabilityAccountOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeFrom.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        res?.feeFrequencyOptions
          ?.filter((item) => item?.value !== "Invalid")
          .forEach((element) => {
            tempFeeFrequency.push({ value: element.id, label: element.value });
          });

        res?.paymentTypeOptions?.forEach((element) =>
          tempPaymentType.push({ value: element.id, label: element.name })
        );

        setChargeApplyData(tempChargeApply);
        setCurrencyData(tempCurrency);
        setChargeMethodData(tempChargeMethod);
        setTaxGroupOptions(tempTaxGroup);
        setIncomeFromChargeOptions(tempIncomeFrom);
        setFeeFrequencyOptions(tempFeeFrequency);
        // setPaymentTypeOptions(tempPaymentType);

        // build per-apply arrays for switching
        const tempLCharge = [];
        const tempLCalc = [];
        const tempSCharge = [];
        const tempSCalc = [];
        const tempCCharge = [];
        const tempCCalc = [];
        const tempShCharge = [];
        const tempShCalc = [];
        const tempTCharge = [];
        const tempTCalc = [];

        res?.loanChargeTimeTypeOptions?.forEach((e) =>
          tempLCharge.push({ value: e.id, label: e.value })
        );
        res?.loanChargeCalculationTypeOptions?.forEach((e) =>
          tempLCalc.push({ value: e.id, label: e.value })
        );

        res?.savingsChargeTimeTypeOptions?.forEach((e) =>
          tempSCharge.push({ value: e.id, label: e.value })
        );
        res?.savingsChargeCalculationTypeOptions?.forEach((e) =>
          tempSCalc.push({ value: e.id, label: e.value })
        );

        res?.clientChargeTimeTypeOptions?.forEach((e) =>
          tempCCharge.push({ value: e.id, label: e.value })
        );
        res?.clientChargeCalculationTypeOptions?.forEach((e) =>
          tempCCalc.push({ value: e.id, label: e.value })
        );

        res?.shareChargeTimeTypeOptions?.forEach((e) =>
          tempShCharge.push({ value: e.id, label: e.value })
        );
        res?.shareChargeCalculationTypeOptions?.forEach((e) =>
          tempShCalc.push({ value: e.id, label: e.value })
        );

        res?.treasuryChargeTimeTypeOptions?.forEach((e) =>
          tempTCharge.push({ value: e.id, label: e.value })
        );
        res?.treasuryChargeCalculationTypeOptions?.forEach((e) =>
          tempTCalc.push({ value: e.id, label: e.value })
        );

        setTempLoanCharge(tempLCharge);
        setTempLoanCalc(tempLCalc);
        setTempSavingsCharge(tempSCharge);
        setTempSavingsCalc(tempSCalc);
        setTempClientCharge(tempCCharge);
        setTempClientCalc(tempCCalc);
        setTempSharesCharge(tempShCharge);
        setTempSharesCalc(tempShCalc);
        setTempTreasuryCharge(tempTCharge);
        setTempTreasuryCalc(tempTCalc);

        // set initial filtered lists depending on applyToParam
        switch (applyToParam) {
          case 1:
            setFilteredChargeCalcTypeData(tempLCalc);
            setFilteredChargeTimeTypeData(tempLCharge);
            setChargeCalcTypeData(tempLCalc);
            setChargeTimeTypeData(tempLCharge);
            break;
          case 2:
            setFilteredChargeCalcTypeData(tempSCalc);
            setFilteredChargeTimeTypeData(tempSCharge);
            setChargeCalcTypeData(tempSCalc);
            setChargeTimeTypeData(tempSCharge);
            break;
          case 3:
            setFilteredChargeCalcTypeData(tempCCalc);
            setFilteredChargeTimeTypeData(tempCCharge);
            setChargeCalcTypeData(tempCCalc);
            setChargeTimeTypeData(tempCCharge);
            break;
          case 4:
            setFilteredChargeCalcTypeData(tempShCalc);
            setFilteredChargeTimeTypeData(tempShCharge);
            setChargeCalcTypeData(tempShCalc);
            setChargeTimeTypeData(tempShCharge);
            break;
          case 5:
            setFilteredChargeCalcTypeData(tempTCalc);
            setFilteredChargeTimeTypeData(tempTCharge);
            setChargeCalcTypeData(tempTCalc);
            setChargeTimeTypeData(tempTCharge);
            break;
          default:
            setFilteredChargeCalcTypeData([]);
            setFilteredChargeTimeTypeData([]);
            setChargeCalcTypeData([]);
            setChargeTimeTypeData([]);
            break;
        }

        // set flags based on existingDetail chargeTimeType label (if provided)
        if (existingDetail?.chargeTimeType?.id) {
          const selectedTime =
            (
              tempLCharge
                .concat(tempSCharge)
                .concat(tempCCharge)
                .concat(tempShCharge)
                .concat(tempTCharge)
                .find((i) => i.value === existingDetail.chargeTimeType.id) || {}
            ).label?.toLowerCase() || "";
          switch (selectedTime) {
            case "monthly fee":
              setIsMonthlyFee(true);
              setIsAnnualFee(true);
              setIsWeeklyFee(true);
              setIsWithdrawalFee(false);
              break;
            case "annual fee":
              setIsAnnualFee(true);
              setIsMonthlyFee(true);
              setIsWeeklyFee(false);
              setIsWithdrawalFee(false);
              break;
            case "weekly fee":
              setIsWeeklyFee(true);
              setIsMonthlyFee(true);
              setIsAnnualFee(false);
              setIsWithdrawalFee(false);
              break;
            case "withdrawal fee":
              setIsWithdrawalFee(true);
              setIsMonthlyFee(false);
              setIsAnnualFee(false);
              setIsWeeklyFee(false);
              break;
            default:
              setIsMonthlyFee(false);
              setIsAnnualFee(false);
              setIsWeeklyFee(false);
              setIsWithdrawalFee(false);
          }
        }

        setIsLoading(false);
      }
    });
  };

  const getPaymentTypes = () => {
    const url = chargeApi.Paymenttypes;
    const body = { session };
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const tp = res?.map((x) => ({ value: x.id, label: x.name })) || [];
        setPaymentTypeOptions(tp);
        // console.log(tp)
      }
    });
  };

  console.log(paymentTypeOptions);

  const handleChargeTypeChange = (value, option) => {
    const label = option?.label?.toLowerCase();
    switch (label) {
      case "monthly fee":
        setIsMonthlyFee(true);
        setIsAnnualFee(true);
        setIsWeeklyFee(true);
        setIsWithdrawalFee(false);
        break;
      case "annual fee":
        setIsAnnualFee(true);
        setIsMonthlyFee(true);
        setIsWeeklyFee(false);
        setIsWithdrawalFee(false);
        break;
      case "weekly fee":
        setIsWeeklyFee(true);
        setIsMonthlyFee(true);
        setIsAnnualFee(false);
        setIsWithdrawalFee(false);
        break;
      case "withdrawal fee":
        setIsWithdrawalFee(true);
        setIsMonthlyFee(false);
        setIsAnnualFee(false);
        setIsWeeklyFee(false);
        break;
      default:
        setIsMonthlyFee(false);
        setIsAnnualFee(false);
        setIsWeeklyFee(false);
        setIsWithdrawalFee(false);
    }
  };

  const onCancel = () => {
    navigate("/prd1000", { replace: false });
  };

  const onSubmit = (formValues) => {
    if (formValues.feeOnMonthDay) {
      formValues.feeOnMonthDay = BOM.DateTimeWithoutYear(
        formValues.feeOnMonthDay,
        "only-date"
      );
    }
    delete formValues.addfeefrequency;
    const url = `${chargeApi.Charges}/${state.id}`;
    const body = {
      ...formValues,
      locale: "en",
      monthDayFormat: "dd MMM",
      method: "PUT",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, chargeLabel.editChargeMsg);
          navigate("/charge-detail", { state: { id: res.resourceId } });
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          navigate("/prd1000");
          setIsLoading(false);
        },
      }
    );
  };

  const disabledPastDate = (current) => {
    // Disable dates before today
    return current && current.isBefore(dayjs().startOf("day"));
  };


  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={chargeLabel.editCharge}
        pageItems={chargeStatic.editChargeItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            initialValues={{
              active: true,
              penalty: false,
              enableFreeWithdrawalCharge: false,
              enablePaymentType: false,
            }}
          >
            <Row>
              <Title level={4} style={{ margin: 0 }}>
                {chargeLabel.chargeSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeAppliesTo}
                  name="chargeAppliesTo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeAppliesTo),
                    },
                  ]}
                >
                  <Select
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeAppliesTo} *`,
                      "select"
                    )}
                    options={chargeApplyData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeName}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeName),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      chargeLabel.chargeName
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.currency}
                  name="currencyCode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.currency),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.currency} *`,
                      "select"
                    )}
                    options={currencyData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.amount}
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.amount),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(chargeLabel.amount)}
                    style={{ width: "100%", ...styles.ofInputFieldNumber }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeTimeType}
                  name="chargeTimeType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeTimeType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeTimeType} *`,
                      "select"
                    )}
                    options={filteredChargeTimeTypeData}
                    onChange={handleChargeTypeChange}
                    showSearch
                  />
                </Form.Item>
              </Col>

              {isWithdrawalFee && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.enablePaymentType}
                      name="enablePaymentType"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.enablePaymentType}`,
                          "select"
                        )}
                        options={chargeStatic.statusData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>

                  {enablePaymentType && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={chargeLabel.paymentTypes}
                        name="paymentTypeId"
                      >
                        <Select
                          placeholder={BOM.handlePlaceholderMsg(
                            `${chargeLabel.paymentTypes} *`,
                            "select"
                          )}
                          options={paymentTypeOptions}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.enableFreeWithdrawal}
                      name="enableFreeWithdrawalCharge"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.enableFreeWithdrawal}`,
                          "select"
                        )}
                        options={chargeStatic.statusData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>

                  {enableFreeWithdrawalCharge && (
                    <>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.noOfFreeWithdrawals}
                          name="freeWithdrawalFrequency"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.noOfFreeWithdrawals
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={BOM.handlePlaceholderMsg(
                              chargeLabel.noOfFreeWithdrawals
                            )}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.restartCountingEvery}
                          name="restartCountFrequency"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.restartCountingEvery
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={BOM.handlePlaceholderMsg(
                              chargeLabel.restartCountingEvery
                            )}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.restartCountFrequency}
                          name="countFrequencyType"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.restartCountFrequency
                              ),
                            },
                          ]}
                        >
                          <Select
                            placeholder={BOM.handlePlaceholderMsg(
                              `${chargeLabel.restartCountFrequency} *`,
                              "select"
                            )}
                            options={feeFrequencyOptions}
                            showSearch
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              )}

              {isMonthlyFee && (
                <>
                  {isAnnualFee && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={chargeLabel.dueDate}
                        name="feeOnMonthDay"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(chargeLabel.dueDate),
                          },
                        ]}
                      >
                        <DatePicker
                          disabledDate={disabledPastDate}
                          style={{ width: "100%", height: 32.5 }}
                          format={dateFormat}
                          placeholder={BOM.handlePlaceholderMsg(
                            chargeLabel.dueDate,
                            "select"
                          )}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {isWeeklyFee && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={`${chargeLabel.repeatsEvery} ${
                          !isAnnualFee ? "Week" : "Months"
                        }`}
                        name="feeInterval"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(chargeLabel.repeatsEvery),
                          },
                        ]}
                      >
                        <Input
                          placeholder={BOM.handlePlaceholderMsg(
                            "interval period"
                          )}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </>
              )}

              {appliesToLoan && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={chargeLabel.incomeFromCharge}
                    name="incomeAccountId"
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        `${chargeLabel.incomeFromCharge} *`,
                        "select"
                      )}
                      options={incomeFromChargeOptions}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.status} name="active">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.status}`,
                      "select"
                    )}
                    options={chargeStatic.statusData}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.isPenalty} name="penalty">
                  <Select
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.isPenalty}`,
                      "select"
                    )}
                    options={chargeStatic.trueFalseData}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeCalculationType}
                  name="chargeCalculationType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        chargeLabel.chargeCalculationType
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeCalculationType} *`,
                      "select"
                    )}
                    options={filteredChargeCalcTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargePaymentMode}
                  name="chargePaymentMode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargePaymentMode),
                    },
                  ]}
                >
                  <Select
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargePaymentMode} *`,
                      "select"
                    )}
                    options={chargeMethodData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.taxGroup} name="taxGroupId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.taxGroup} *`,
                      "select"
                    )}
                    options={taxGroupOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.addFeeFrequency}
                  name="addfeefrequency"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.addFeeFrequency}`,
                      "select"
                    )}
                    options={chargeStatic.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              {addFeeFrequencyCheck && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.chargeFrequency}
                      name="countFrequencyType"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(chargeLabel.chargeFrequency),
                        },
                      ]}
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.chargeFrequency} *`,
                          "select"
                        )}
                        options={feeFrequencyOptions}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.frequencyInterval}
                      name="feeInterval"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(
                            chargeLabel.frequencyInterval
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          chargeLabel.frequencyInterval
                        )}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_CHARGE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(EditCharge);
